import { SettlementsType } from '../type/settlements.type';

export const settlementsInitial: SettlementsType = {
    data: [],
    count: 0,
    page: 0,
};
